import httpClient from '@emmacare/common/api/httpClient'

import {
  CHAT,
  CHATS,
  CHATS_UNREAD_COUNTER,
  CHAT_MESSAGE,
  CHAT_MESSAGES,
  CHAT_MESSAGE_ACKNOWLEDGEMENT
} from 'src/constants'

export default {
  getChats(query) {
    return httpClient.get({
      pathname: CHATS,
      query
    })
  },
  getChat(params) {
    return httpClient.get({
      pathname: CHAT,
      params
    })
  },
  getChatMessage(params) {
    return httpClient.get({
      pathname: CHAT_MESSAGE,
      params
    })
  },
  getChatMessages(params, query) {
    return httpClient.get({
      pathname: CHAT_MESSAGES,
      params,
      query
    })
  },
  postChatMessage(params, payload, customHeaders) {
    return httpClient.post(
      {
        pathname: CHAT_MESSAGES,
        params
      },
      payload,
      customHeaders
    )
  },
  postChatMessageAcknowledgement(params) {
    return httpClient.post({
      pathname: CHAT_MESSAGE_ACKNOWLEDGEMENT,
      params
    })
  },
  getUnreadChatsAmount() {
    return httpClient.get(CHATS_UNREAD_COUNTER)
  }
}
